<template lang="pug">
div.goal(v-if="goal")
  div.goal-description
    goal-icon( :title="goal.title" :height="48" :width="48" )
    div.goal-title
      div.text-16-b {{goal.title}}
      div.price.text-14 Цель: {{ returnMaskPrice(goal.full_amount) }} {{ convertToValueLabel('RUR')}}
  .progress
    progress-circle( :progress="goalPercent")
  div.mt-2.progress-text
    div.text-14 Накоплено: {{ returnMaskPrice(goal.accumulated_amount) }} {{convertToValueLabel('RUR')}}
    div.ml-6.text-14 Осталось: {{ returnMaskPrice(remainingAmount) }} {{convertToValueLabel('RUR')}}
  div.button-container.text-14
    button.button( @click="changeActiveGoal" ) Изменить
    button.ml-4.button( @click="editGoal" ) Редактировать
div(v-else).no-activegoal
  span.text-16 У вас нет активной цели
  
</template>

<script>
import ProgressCircle from '../ProgressCircle.vue';
export default {
  name: 'ActiveGoalBlock',
  components: {
    ProgressCircle
  },

  props: {
    goal: null,
  },

  computed: {
    remainingAmount() {
      return this.goal.full_amount - this.goal.accumulated_amount
    },

    goalPercent() {
      return (this.goal.accumulated_amount/this.goal.full_amount) * 100
    }
  },

  methods: {
    returnMaskPrice(value) {
      return value.toLocaleString("ru-RU").replace(/\s/g, ",")
    },

    editGoal() {
      this.$emit('editGoal', this.goal)
    },

    changeActiveGoal() {
      this.$router.push(`/allGoals/${'unactiveGoals'}/${this.goal.uuid}`)
    }
  }
}

</script>
<style scoped>
.goal {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #5365E5;
  border-radius: 16px;
  border-width: 1px;
}
.icon {
  padding: 16px 14px;
}
.goal-description {
  margin-top: 12px;
  align-items: end;
  display: flex;
  flex-direction: row;
}
.goal-title {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}
.price {
  color: #6B7280;
}
.progress {
  margin-top: 15px;
  display: flex;
}
.progress-text {
  display: flex;
  flex-direction: row;
  color: #4B5563;
}
.button-container {
  align-items: center;
}
.button {
  margin-top: 12px;
  margin-bottom: 8px;
  color: #FFFFFF;
  width: 130px;
  height: 36px;
  border-radius: 12px;
  background: #5365E5;
}
.no-activegoal {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
